import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk to create an order and process payment
export const createOrderAndPayment = createAsyncThunk(
  "orders/createOrderAndPayment",
  async (
    {
      items,
      amount,
      paymentSource,
      customerId,
      appliedDiscounts,
      taxRate,
      userinfo,
      businessId,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post(
        "https://api.aweioio.com/api/create-order-and-payment",
        {
          items,
          amount,
          paymentSource,
          customerId,
          appliedDiscounts,
          taxRate,
          userinfo,
          businessId,
        } // Include taxRate
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to create order and payment"
      );
    }
  }
);

const ordersSlice = createSlice({
  name: "orders",
  initialState: {
    orderId: null,
    paymentDetails: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetOrderState: (state) => {
      state.orderId = null;
      state.paymentDetails = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOrderAndPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createOrderAndPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.orderId = action.payload.orderId;
        state.paymentDetails = action.payload.paymentDetails;
      })
      .addCase(createOrderAndPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong.";
      });
  },
});

export const { resetOrderState } = ordersSlice.actions;

export default ordersSlice.reducer;
